import React from "react";

const daysOfWeek = [
    { name: "Пн", value: "Monday" },
    { name: "Вт", value: "Tuesday" },
    { name: "Ср", value: "Wednesday" },
    { name: "Чт", value: "Thursday" },
    { name: "Пт", value: "Friday" },
    { name: "Сб", value: "Saturday" },
    { name: "Вс", value: "Sunday" },
];

const DaysInput = ({ days = {}, activeDay, onSelectDay }) => {
    return (
        <div className="admin_works-time_inputs-days">
            <div className="inputs-days__label">Выберите рабочие дни недели</div>
            <div className="inputs-days">
                {daysOfWeek.map((day) => {
                    const intervals = days[day.value] || [];
                    const isSelected = intervals.some(i => i.start && i.end);
                    const isActive = activeDay === day.value;
                    return (
                        <div
                            key={day.value}
                            className={`day-label ${isActive ? "active" : ""} ${isSelected ? "selected" : ""}`}
                            onClick={() => onSelectDay(day.value)}
                        >
                            {day.name}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DaysInput;
